<template>
  <div id="footer" class="container-fluid">
    <div class="hidden-xs">
      <div class="logo">
        Mandarin
      </div>
        <p class="copy">
          {{ footList.license_no }}　Copyright © {{ footList.copyright }}　{{ footList.links }} &nbsp;&nbsp; All rights reserved.　{{ footList.icp_no }}　
          <!-- <a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备13030698号-5</a> -->
      </p>
    </div>
    <div class="visible-xs">
      <div class="logo">
        Mandarin
      </div>
        <p class="copy">
          <span> {{ footList.license_no }}</span><br/>
          <span>Copyright © {{ footList.copyright }}</span><br/>
          <span>{{ footList.links }} &nbsp;&nbsp; All rights reserved.</span><br/>
          <span>{{ footList.icp_no }}</span>
          <!-- <a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备13030698号-5</a> -->
      </p>
    </div>
  </div>
</template>
<script>
 import {getFooterList} from "../api/api";
export default {
  name: "Footer",
  data() {
    return {
      footList:{}
    };
  },
  created() {
          this.getList()
      },
      methods:{
      getList() {
        getFooterList().then(res => {
          if(res.code == 0) {
              this.footList = res.data.list
              console.log(this.footList,'this.footList');
          }
        })
      },
    }
};
</script>
<style scoped lang='less'>
#footer {
  width: 100%;
  height: 100%;
  color: #0D263C;
  background: #fff;
  font-family: 'Open Sans Light';
  overflow: hidden;
  text-align: center;
}
.logo {
  margin: 20px auto;
  font-size: 44px;
  font-family: 'Open Sans';
  color: #0D263C;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color:  #0D263C;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #0D263C;
  font-size: 14px;
}
.copy {
  color: #0D263C;
  font-size: 14px;
  margin-bottom: 20px;
  span {
    margin-bottom: 5px;
    display: inline-block;
  }
  a {
    text-decoration:none;
    color:#0D263C;
  }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
   /* margin-bottom: 22px; */
}
.logo {
  margin: 17px auto;
}
}
.awards_bg {
  height: 80px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue